import type { SyntheticEvent } from 'react';

// introduced at https://github.com/mui-org/material-ui/blob/c13deae820188f1ede7fbb8511a496b30856770e/packages/material-ui/src/Tooltip/Tooltip.js#L156
export function composeEventHandler<E extends SyntheticEvent>(
  customEventHandler: (event: E) => void,
  originalEventHandler: ((event: E) => void) | undefined | null
) {
  return (event: E) => {
    if (originalEventHandler) {
      originalEventHandler(event);
    }

    customEventHandler(event);
  };
}
